<script setup lang="ts">
interface OwnProps {
  text: string
  isSoon?: boolean
}

defineProps<OwnProps>()

const { colors } = useTheme()
</script>

<template>
  <Text style="font-family: Circular Std Book, sans-serif" variant="normal" :font-weight="600" :color="colors.black" mb-16px>
    {{ text }}
    <span v-if="isSoon" :style="{ 'font-family': 'Circular Std Book', 'color': colors.darkGray }" mb-16px>
      (Soon)
    </span>
  </Text>
</template>
